// src/infrastructure/store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { getUserIdFromDecodedToken } from "../utils/jwtClaims";
import { expireSession } from "../utils/sessionExpiration";

const loadInitialState = () => {
  const token = localStorage.getItem("token");
  if (!token) return { token: null, userId: null };

  try {
    const decoded = jwtDecode(token);
    if (typeof decoded.exp === "number" && decoded.exp * 1000 <= Date.now()) {
      expireSession();
      return { token: null, userId: null };
    }
    return { token, userId: getUserIdFromDecodedToken(decoded) };
  } catch (e) {
    expireSession();
    return { token: null, userId: null };
  }
};

const authSlice = createSlice({
  name: "authToken",
  initialState: loadInitialState(),
  reducers: {
    addToken(state, { payload }) {
      let token, userId;
      if (typeof payload === "string") {
        token = payload;
        userId = getUserIdFromDecodedToken(jwtDecode(token));
      } else {
        token = payload.token;
        userId = payload.user.idUsuario || payload.user.nameid;
      }
      state.token = token;
      state.userId = userId;
      localStorage.setItem("token", token);
    },
    deleteToken(state) {
      state.token = null;
      state.userId = null;
      localStorage.removeItem("token");
    },
  },
});

export const { addToken, deleteToken } = authSlice.actions;
export default authSlice.reducer;
